import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const icon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

const fmtDT = (iso) => { try { return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

export const CheckinMap = ({ points }) => {
  const center = [points[0].location.lat, points[0].location.lng];
  return (
    <MapContainer center={center} zoom={12} scrollWheelZoom={false} style={{ height: 340, width: "100%", borderRadius: 8, zIndex: 0 }} data-testid="checkin-map">
      <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {points.map((c) => (
        <Marker key={c.id} position={[c.location.lat, c.location.lng]} icon={icon}>
          <Popup>
            <span className="font-semibold">{c.operator_name}</span><br />
            {c.commessa_name}<br />
            <span className="text-slate-500">{fmtDT(c.checked_in_at)}</span>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};
